const formatTranslation = (template, replacements = {}) => {
  if (typeof template !== 'string') {
    return typeof template === 'number' ? String(template) : template ?? '';
  }

  return Object.entries(replacements).reduce((acc, [key, value]) => {
    if (value === undefined || value === null) {
      return acc.replace(new RegExp(`{{\\s*${key}\\s*}}`, 'g'), '');
    }
    return acc.replace(new RegExp(`{{\\s*${key}\\s*}}`, 'g'), String(value));
  }, template);
};

export default formatTranslation;
